import React from 'react';
import LayoutSearch from './LayoutSearch';
import Pagination from '../Pagination';

export const SearchResults = ({ results, searchQuery, pagination, totalResults }) => {
  return (
    <div className="layoutSearch">
      <div className="Content">
        <div className="Content__productsCategories">
          <div className="container">
            <LayoutSearch
              products={results}
              searchQuery={searchQuery}
              totalResults={totalResults}
              serverPaginated={true}
            />
            {pagination && pagination.lastPage > 1 && (
              <div style={{ marginTop: 24 }}>
                <Pagination
                  currentPage={pagination.currentPage}
                  totalPages={pagination.lastPage}
                  onPageChange={pagination.onPageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};